import BaseApi from 'common/apiRequest/apis/BaseApi';
import { Request } from '../apiConcentrator/Admin';
import APINames from '../APINames';

class AppStoreApi extends BaseApi {
  public requestInstance = new Request(APINames.APP_STORE);
}
export default new AppStoreApi();
